var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGatein(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1397_2600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.6665 2.66675H10.6665C11.0201 2.66675 11.3593 2.80722 11.6093 3.05727C11.8594 3.30732 11.9998 3.64646 11.9998 4.00008V13.3334",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 13.3333H3.3335",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6665 13.3333H14.6665",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66634 3.04138V13.8127C8.66631 13.914 8.64322 14.0139 8.5988 14.1049C8.55439 14.1959 8.48983 14.2756 8.41002 14.3379C8.33021 14.4003 8.23725 14.4436 8.1382 14.4646C8.03914 14.4857 7.9366 14.4839 7.83834 14.4594L3.33301 13.3334V3.70805C3.33305 3.41072 3.43248 3.12194 3.61548 2.8876C3.79848 2.65327 4.05456 2.48682 4.34301 2.41472L7.00967 1.74805C7.20617 1.69893 7.41128 1.69523 7.60943 1.73722C7.80757 1.77921 7.99355 1.86579 8.15323 1.99039C8.31292 2.11499 8.44212 2.27434 8.53103 2.45633C8.61993 2.63832 8.66621 2.83884 8.66634 3.04138Z",
    fill: "#172B4D",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 8V8.00667",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1397_2600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatein);
export default __webpack_public_path__ + "static/media/gatein.cda87b22bc2dda95ac4fb234d4f78953.svg";
export { ForwardRef as ReactComponent };